import React, { useState } from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  pdf,
} from '@react-pdf/renderer';
import { Button } from 'antd';
import { DownloadOutlined, FilePdfOutlined } from '@ant-design/icons';

// ─────────────────────────────────────────────
// DATOS DE PRUEBA
// ─────────────────────────────────────────────
const MOCK_DATA = {
  generadoEl: '28/05/2026',
  resumen: {
    totalProyectos: 20,
    totalPlanificado: 7148037713,
    totalEntregadoSinIva: 1095452144,
    totalEntregadoConIva: 1150916503,
    promedioAvance: 15.1,
    proyectosSinInicio: 5,
    proyectosEnProceso: 15,
    proyectosCompletos: 0,
  },
  proyectos: [
    { codigo_interno: 'ES-0004', implementador: 'COOMUNTU',          total_cantidad_plan: 34,     valor_planificado_total: 246087472,  valor_entregado_con_iva: 80642193,  valor_entregado_sin_iva: 76811612,  porcentaje_avance: 32.8 },
    { codigo_interno: 'ES-0009', implementador: 'EPZ',               total_cantidad_plan: 5,      valor_planificado_total: 400000000,  valor_entregado_con_iva: 0,         valor_entregado_sin_iva: 0,         porcentaje_avance: 0   },
    { codigo_interno: 'ES-0010', implementador: 'ACOPAZ',            total_cantidad_plan: 10042,  valor_planificado_total: 399032108,  valor_entregado_con_iva: 160302600, valor_entregado_sin_iva: 134708908, porcentaje_avance: 40.2 },
    { codigo_interno: 'ES-0012', implementador: 'ASOEMANCIPADORAS',  total_cantidad_plan: 6193,   valor_planificado_total: 353352570,  valor_entregado_con_iva: 23661825,  valor_entregado_sin_iva: 19882206,  porcentaje_avance: 6.7 },
    { codigo_interno: 'ES-0013', implementador: 'COOAGROPAZ',        total_cantidad_plan: 1537,   valor_planificado_total: 400000000,  valor_entregado_con_iva: 337234505, valor_entregado_sin_iva: 283390341, porcentaje_avance: 84.3 },
    { codigo_interno: 'ES-0015', implementador: 'COOMFROSUR',        total_cantidad_plan: 15624,  valor_planificado_total: 399921149,  valor_entregado_con_iva: 171530979, valor_entregado_sin_iva: 144143679, porcentaje_avance: 42.9 },
    { codigo_interno: 'ES-0018', implementador: 'HATO CASTILLO',     total_cantidad_plan: 219,    valor_planificado_total: 307024000,  valor_entregado_con_iva: 0,         valor_entregado_sin_iva: 0,         porcentaje_avance: 0   },
    { codigo_interno: 'ES-0021', implementador: 'COAGRANCC',         total_cantidad_plan: 14096,  valor_planificado_total: 324767000,  valor_entregado_con_iva: 34538600,  valor_entregado_sin_iva: 29024034,  porcentaje_avance: 10.6 },
    { codigo_interno: 'ES-0025', implementador: 'COOPATIAS',         total_cantidad_plan: 3624,   valor_planificado_total: 394509000,  valor_entregado_con_iva: 26449191,  valor_entregado_sin_iva: 22226219,  porcentaje_avance: 6.7 },
    { codigo_interno: 'ES-0026', implementador: 'CEMAS',             total_cantidad_plan: 30389,  valor_planificado_total: 399996200,  valor_entregado_con_iva: 0,         valor_entregado_sin_iva: 0,         porcentaje_avance: 0   },
  ],
  paginaActual: 1,
  totalPaginas: 2,
  porPagina: 10,
};

// ─────────────────────────────────────────────
// UTILIDADES
// ─────────────────────────────────────────────
const fmt = (n) =>
  new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  }).format(n);

const fmtNum = (n) => new Intl.NumberFormat('es-CO').format(n);



// ─────────────────────────────────────────────
// COLORES PDF
// ─────────────────────────────────────────────
const C = {
  navy:    '#1e3a5f',
  labelBg: '#dce6f0',
  border:  '#b0bec5',
  rowAlt:  '#f5f8fb',
  totalBg: '#dce6f0',
  white:   '#ffffff',
  gray:    '#546e7a',
  dark:    '#1a2a3a',
};

// ─────────────────────────────────────────────
// ESTILOS PDF
// ─────────────────────────────────────────────
const ps = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 8,
    paddingTop: 26,
    paddingBottom: 34,
    paddingHorizontal: 26,
    backgroundColor: C.white,
    color: C.dark,
  },

  // Page header
  pageHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
    paddingBottom: 7,
    borderBottomWidth: 1.5,
    borderBottomColor: C.navy,
  },
  pageTitle:    { fontSize: 12, fontFamily: 'Helvetica-Bold', color: C.navy },
  pageSubtitle: { fontSize: 6.5, color: C.gray, marginTop: 2 },

  // Section wrapper
  section:      { marginBottom: 7, borderWidth: 1, borderColor: C.border },

  // Colored header bar
  secHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 5,
    paddingHorizontal: 8,
    backgroundColor: C.navy,
  },
  secHeaderSq:   { width: 7, height: 7, backgroundColor: C.white, marginRight: 6, opacity: 0.8 },
  secHeaderText: { fontFamily: 'Helvetica-Bold', fontSize: 7.5, color: C.white },

  // Label row
  labelRow: {
    flexDirection: 'row',
    backgroundColor: C.labelBg,
    paddingVertical: 3,
    borderBottomWidth: 1,
    borderBottomColor: C.border,
  },
  labelCell:     { flex: 1, textAlign: 'center', fontSize: 6.5, color: C.gray, borderRightWidth: 1, borderRightColor: C.border, paddingHorizontal: 3 },
  labelCellLast: { flex: 1, textAlign: 'center', fontSize: 6.5, color: C.gray, paddingHorizontal: 3 },

  // Value row
  valueRow:      { flexDirection: 'row', backgroundColor: C.white, paddingVertical: 6 },
  valueCell:     { flex: 1, textAlign: 'center', fontFamily: 'Helvetica-Bold', fontSize: 8.5, color: C.dark, borderRightWidth: 1, borderRightColor: C.border, paddingHorizontal: 3 },
  valueCellLast: { flex: 1, textAlign: 'center', fontFamily: 'Helvetica-Bold', fontSize: 8.5, color: C.dark, paddingHorizontal: 3 },

  // Table col headers
  tHead: {
    flexDirection: 'row',
    backgroundColor: C.navy,
    paddingVertical: 4,
    paddingHorizontal: 4,
  },
  th: { fontFamily: 'Helvetica-Bold', fontSize: 6.5, color: C.white },

  // Table rows
  tRow:     { flexDirection: 'row', paddingVertical: 3.5, paddingHorizontal: 4, borderBottomWidth: 1, borderBottomColor: C.border, backgroundColor: C.white },
  tRowAlt:  { backgroundColor: C.rowAlt },
  tRowTotal:{ flexDirection: 'row', paddingVertical: 4.5, paddingHorizontal: 4, backgroundColor: C.totalBg, borderTopWidth: 1.2, borderTopColor: C.navy },
  td:       { fontSize: 7, color: C.dark },
  tdB:      { fontFamily: 'Helvetica-Bold', fontSize: 7, color: C.dark },

  // col widths
  cCod:   { width: '10%' },
  cImpl:  { width: '22%' },
  cCant:  { width: '11%', textAlign: 'right' },
  cValor: { width: '19%', textAlign: 'right' },
  cEjec:  { width: '19%', textAlign: 'right' },
  cDif:   { width: '19%', textAlign: 'right' },

  // Footer
  footer: {
    position: 'absolute', bottom: 14, left: 26, right: 26,
    flexDirection: 'row', justifyContent: 'space-between',
    borderTopWidth: 0.5, borderTopColor: C.border, paddingTop: 4,
  },
  footerText: { fontSize: 6, color: C.gray },

  note: {
    marginTop: 5, paddingVertical: 3, paddingHorizontal: 6,
    backgroundColor: '#fffde7', borderLeftWidth: 2, borderLeftColor: '#f9a825',
  },
  noteText: { fontSize: 6, color: '#5d4037' },
});

// ── PDF helper: summary section ──
const PdfSection = ({ cols }) => (
  <View>
    <View style={ps.labelRow}>
      {cols.map((c, i) =>
        i < cols.length - 1
          ? <Text key={i} style={ps.labelCell}>{c.label}</Text>
          : <Text key={i} style={ps.labelCellLast}>{c.label}</Text>
      )}
    </View>
    <View style={ps.valueRow}>
      {cols.map((c, i) =>
        i < cols.length - 1
          ? <Text key={i} style={ps.valueCell}>{c.value}</Text>
          : <Text key={i} style={ps.valueCellLast}>{c.value}</Text>
      )}
    </View>
  </View>
);

// ─────────────────────────────────────────────
// DOCUMENTO PDF
// ─────────────────────────────────────────────
const InformePDF = ({ data }) => {
  const r = data.resumen;
  // Los totales ya vienen precalculados en r (resumen), no se necesita reduce

  return (
    <Document title="Informe General por Proyecto" author="Sistema de Gestión">
      <Page size="A4" style={ps.page}>

        {/* ── PAGE HEADER ── */}
        <View style={ps.pageHeader}>
          <View>
            <Text style={ps.pageTitle}>Informe General por Proyecto</Text>
            <Text style={ps.pageSubtitle}>
              Generado el {data.generadoEl} 
            </Text>
          </View>
        </View>

        {/* ── RESUMEN GENERAL ── */}
        <View style={ps.section}>
          <View style={ps.secHeader}>
            <View style={ps.secHeaderSq} />
            <Text style={ps.secHeaderText}>Informe General por Proyecto</Text>
          </View>

          {/* Fila 1: totales numéricos */}
          <PdfSection cols={[
            { label: 'Total Proyectos',             value: String(r.totalProyectos) },
            { label: 'Valor Planificado',            value: fmt(r.totalPlanificado) },
            { label: 'Valor Entregado (Sin IVA)',    value: fmt(r.totalEntregadoSinIva) },
            { label: 'Valor Asignado (Con IVA)',     value: fmt(r.totalEntregadoConIva) },
            { label: 'Avance Promedio',              value: `${ Number((Number(r.promedioAvance) || 0).toFixed(2))} %` },
          ]} />

          {/* Fila 2: estados */}
          <PdfSection cols={[
            { label: 'Sin Inicio',  value: String(r.proyectosSinInicio) },
            { label: 'En Proceso',  value: String(r.proyectosEnProceso) },
            { label: 'Completos',   value: String(r.proyectosCompletos) },
          ]} />
        </View>

        {/* ── TABLA DE PROYECTOS ── */}
        <View style={[ps.section, { borderWidth: 1, borderColor: C.border }]}>
          {/* header bar */}
          <View style={ps.secHeader}>
            <View style={ps.secHeaderSq} />
            <Text style={ps.secHeaderText}>Detalle por Proyecto</Text>
          </View>

          {/* col headers */}
          <View style={ps.tHead}>
            <Text style={[ps.th, ps.cCod]}>Proyecto</Text>
            <Text style={[ps.th, ps.cImpl]}>Implementador</Text>
            <Text style={[ps.th, ps.cCant]}>Cantidad</Text>
            <Text style={[ps.th, ps.cValor]}>Planificado (Valor Total) </Text>
            <Text style={[ps.th, ps.cEjec]}>Ejecutado (Valor Total)</Text>
            <Text style={[ps.th, ps.cDif]}>Diferencia</Text>
            <Text style={[ps.th, ps.cDif]}>% Avance</Text>

          </View>

          {/* data rows */}
          {data.proyectos.map((p, i) => (
            <View key={p.codigo} style={[ps.tRow, i % 2 === 1 && ps.tRowAlt]}>
              <Text style={[ps.tdB, ps.cCod]}>{p.codigo_interno}</Text>
              <Text style={[ps.td,  ps.cImpl]}>{p.implementador}</Text>
              <Text style={[ps.td,  ps.cCant]}>{fmtNum(p.total_cantidad_plan)}</Text>
              <Text style={[ps.td,  ps.cValor]}>{fmt(p.valor_planificado_total)}</Text>
              <Text style={[ps.td,  ps.cEjec]}>{fmt(p.valor_entregado_con_iva)}</Text>
              <Text style={[ps.td,  ps.cDif]}>{fmt(p.valor_planificado_total - p.valor_entregado_con_iva)}</Text>
                <Text
                style={[
                    ps.td,
                    ps.cDif,
                    {
                    color:
                        Number(p.porcentaje_avance) === 0
                        ? "#bfbfbf"
                        : Number(p.porcentaje_avance) === 100
                        ? "#52c41a"
                        : Number(p.porcentaje_avance) >= 75
                        ? "#1890ff"
                        : Number(p.porcentaje_avance) >= 25
                        ? "#fa8c16"
                        : "#ff4d4f",
                    },
                ]}
                >
                {Number(p.porcentaje_avance).toFixed(0)}%
                </Text>
            </View>
          ))}

          {/* total row */}
          <View style={ps.tRowTotal}>
            <Text style={[ps.tdB, ps.cCod]}>TOTALES</Text>
            <Text style={[ps.tdB, ps.cImpl]}></Text>
            <Text style={[ps.tdB, ps.cCant]}></Text>
            <Text style={[ps.tdB, ps.cValor]}>{fmt(r.totalPlanificado)}</Text>
            <Text style={[ps.tdB, ps.cEjec]}>{fmt(r.totalEntregadoConIva)}</Text>
            <Text style={[ps.tdB, ps.cDif]}>{fmt(r.totalPlanificado - r.totalEntregadoConIva)}</Text>
            <Text style={[ps.tdB, ps.cDif]}></Text>

          </View>
        </View>

        {/* ── NOTA ── */}
        <View style={ps.note}>
          <Text style={ps.noteText}>
            * Muestra {data.proyectos.length} de {r.totalProyectos} proyectos.
            La diferencia corresponde a: Valor Total Planificado − Valor Entregado Con IVA.
          </Text>
        </View>

        {/* ── FOOTER ── */}
        <View style={ps.footer} fixed>
          <Text style={ps.footerText}>Informe General por Proyecto — Confidencial</Text>
          <Text
            style={ps.footerText}
            render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
          />
        </View>

      </Page>
    </Document>
  );
};

// ─────────────────────────────────────────────
// COMPONENTE PRINCIPAL — solo botón de descarga
// ─────────────────────────────────────────────
const InformeProyectosPDF = ({ data }) => {
  const reportData = data || MOCK_DATA;
  const [generating, setGenerating] = useState(false);

  const handleDownload = async () => {
    try {
      setGenerating(true);
      const blob = await pdf(<InformePDF data={reportData} />).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const fileName = `informe_proyectos_${reportData.generadoEl.replace(/[/ :]/g, '-')}.pdf`;
      link.href = url;
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error generando PDF:', error);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <Button
      danger
      type="primary"
      icon={<FilePdfOutlined />}
      loading={generating}
      onClick={handleDownload}
    >
      {generating ? 'Generando PDF...' : 'Exportar PDF'}
    </Button>
  );
};

export default InformeProyectosPDF;